import { render, staticRenderFns } from "./PageInfoBar.vue?vue&type=template&id=6720790b&scoped=true"
import script from "./PageInfoBar.vue?vue&type=script&lang=js"
export * from "./PageInfoBar.vue?vue&type=script&lang=js"
import style0 from "./PageInfoBar.vue?vue&type=style&index=0&id=6720790b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6720790b",
  null
  
)

export default component.exports